import api from "../lib/axios";

export const notificationService = {
  setFcmToken: async (data: { device_token: string }) => {
    const response = await api.post("/manufacturer/notifications/fcm-token", data);
    return response.data;
  },
  list: async (params?: { page?: number; limit?: number }) => {
    const response = await api.get("/manufacturer/notifications", { params });
    return response.data;
  },
  markAsRead: async (id: number) => {
    const response = await api.patch(`/manufacturer/notifications/${id}/read`);
    return response.data;
  },
};
